import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, NOTIFICATION_TYPE, notifyMessageCreator } from 'Modules'
import { FormNames } from 'Constants/FormNames'
import { massUseMerchantSlice, MassUseMerchantStateNS, massUseMerchantApi } from 'Pages/pp'

function* createOne(action: MassUseMerchantStateNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(massUseMerchantApi.createOne, action.payload)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'pp.mass_use_merchant_create.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'pp.mass_use_merchant_create.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
		yield* call(errorHandler, error, FormNames.PP.MASS_USE_MERCHANT)
	}
}
function* deleteOne(action: MassUseMerchantStateNS.DeleteOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(massUseMerchantApi.deleteOne, action.payload)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'pp.mass_use_merchant_delete.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'pp.mass_use_merchant_delete.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
		yield* call(errorHandler, error, FormNames.PP.MASS_USE_MERCHANT)
	}
}

export const massUseMerchantSaga = function* saga() {
	yield* takeLatest(massUseMerchantSlice.actions.createOne.type, createOne)
	yield* takeLatest(massUseMerchantSlice.actions.deleteOne.type, deleteOne)
}
